import { useCallback, useState } from "react";
import { updateSurvey } from "../api/survey.api";
import type { UpdateSurveyRequest } from "../types/survey.types";

export const useUpdateSurvey = () => {
  const [loading, setLoading] = useState(false);

  const updateSurveyRequest = useCallback(async (id: string, request: UpdateSurveyRequest) => {
    try {
      setLoading(true);
      return await updateSurvey(id, request);
    } finally {
      setLoading(false);
    }
  }, []);

  return { updateSurvey: updateSurveyRequest, loading };
};

export type UseUpdateSurveyReturn = ReturnType<typeof useUpdateSurvey>;
